// extracted by mini-css-extract-plugin
export var label = "styles-module--label--bNlpr";
export var stickyLabel = "styles-module--stickyLabel--pZLMK";
export var isSticky = "styles-module--isSticky--+xbGS";